var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-sr",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#377e3f",
    d: "M.1 0h640v480H.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.1 96h640v288H.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#b40a2d",
    d: "M.1 144h640v192H.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ecc81d",
    d: "m320 153.2 56.4 173.6-147.7-107.3h182.6L263.6 326.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSr);
export default __webpack_public_path__ + "static/media/sr.f281cc96dc94e9f2bcdf35155d700dfa.svg";
export { ForwardRef as ReactComponent };